import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import { StylePropType } from 'globals/styles';
import { Message, Attachment } from 'models';
import MessageWithLinks from 'shared/components/MessageWithLinks';
import Modal from 'shared/components/Modal';
import messages from '../ChatMessageForCustomer/messages';
import * as helpers from '../ChatMessageForCustomer/helpers';
import styles from './styles';

export class ChatMessageWithAttachment extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  handleClickImage = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  renderImageModal = () => {
    const { attachment } = this.props;
    const { showModal } = this.state;

    if (showModal) {
      return (
        <Modal onClose={this.handleClickImage}>
          <img src={attachment.preview} alt={attachment.name} style={styles.imgStyles} />
        </Modal>
      );
    }

    return null;
  };
  render() {
    const { attachment, className, message, displayBody, style } = this.props;

    if (isEmpty(attachment)) return null;

    if (!attachment.preview) {
      return (
        <div className={`${className} kustomer-app-thread-customer-message`} style={style}>
          <MessageWithLinks text={displayBody || message.body} />
          <div className="kustomer-app-customer-message-attachment-loading">
            <FormattedMessage {...messages.loading_attachment} />
          </div>
        </div>
      );
    }

    if (helpers.isSupportedImage(attachment)) {
      return (
        <div className={`${className} kustomer-app-thread-customer-message`} style={style}>
          <MessageWithLinks text={displayBody || message.body} />
          <div onClick={this.handleClickImage}>
            <img src={attachment.preview} alt={attachment.name} style={styles.imgPreview} />
          </div>
          {this.renderImageModal()}
        </div>
      );
    }

    return (
      <div className={`${className} kustomer-app-thread-customer-message`} style={style}>
        <MessageWithLinks text={displayBody || message.body} />
        <div>
          <a href={attachment.preview}>{attachment.name}</a>
        </div>
      </div>
    );
  }
}

ChatMessageWithAttachment.propTypes = {
  attachment: PropTypes.instanceOf(Attachment),
  className: PropTypes.string,
  message: PropTypes.instanceOf(Message),
  displayBody: PropTypes.string,
  style: StylePropType,
};

ChatMessageWithAttachment.defaultProps = {
  displayBody: undefined,
};

export default ChatMessageWithAttachment;
